import React from 'react';
import clsx from 'clsx';
import Badge from '../Badge';

interface ArticleHeaderProps {
    articleInfo: { date: string; author: string };
    heading: { tagline: string; title: string; text: string };
    image?: { src: string; srcSmaller?: string; srcMobile?: string; alt: string; figcaption: string };
    imageVariant?: 'small' | 'large' | 'round';
    badges: {
        news?: boolean;
        insights?: boolean;
    };
    customBadge: string[]; // Custom Badge with string
}

export default function ArticleHeader({
    articleInfo,
    heading,
    image,
    imageVariant,
    badges,
    customBadge, 
}: ArticleHeaderProps) {
    return (
        <div className='grid-container article-header'>
            <div className='grid-row'>
                <div className='c-12 c-md-2 article-header__info'>
                    <div className="article-header__date-author">
                        <p>{articleInfo.date}</p>
                        <p>{articleInfo.author}</p>
                    </div>
                    <div className="article-header__badges">
                        <Badge
                            {...badges} // Predefined badges props
                        />
                        {customBadge && customBadge.map((badge, index) => (
                            <Badge key={index} customBadge={[badge]} />
                        ))}
                    </div>
                </div>
                <div className='c-12 c-md-8 article-header__header'>
                    {heading.tagline && <p className='article-header__tagline'>{heading.tagline}</p>}
                    {heading.title && <h1 className='article-header__title'>{heading.title}</h1>}
                    {heading.text && <p className='article-header__text' dangerouslySetInnerHTML={{ __html: heading.text }} suppressHydrationWarning></p>}
                </div>

                {image && (
                    <div className='c-12 c-md-12 article-header__image-wrapper'>
                        <figure className='grid-row article-header__figure'>
                            <picture className={clsx({
                                'c-12 start-md-3 c-md-8 article-header__picture article-header__picture--small': imageVariant === 'small',
                                'c-12 article-header__picture article-header__picture--large': imageVariant === 'large',
                                'c-12 article-header__picture article-header__picture--round': imageVariant === 'round',
                            })}>
                                <source
                                    media="(min-width: 1440px)"
                                    srcSet={`${image.src}`}
                                />
                                <source
                                    media="(max-width: 1439px)"
                                    srcSet={`${image.srcSmaller}`}
                                />
                                <source
                                    media="(max-width: 767px)"
                                    srcSet={`${image.srcMobile}`}
                                />
                                <img src={`${image.src}`} alt={image.alt} />
                            </picture>
                            <figcaption className='start-md-3 c-md-8 article-header__figcaption text-dark'>{image.figcaption}</figcaption>
                        </figure>
                    </div>
                )}
            </div>
        </div>
    );
}
